import React from "react";
import { Tooltip } from "../../../ui/tooltip";

interface TruncatedTextProps {
  text: string;
  maxWidth: number | string;
  className?: string;
  as?: "span" | "div";
  tooltip?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxWidth,
  className,
  as = "span",
  tooltip = true,
  onClick,
}) => {
  const Element: any = as;
  const styleMaxWidth = typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth;

  const content = (
    <Element
      className={`inline-block overflow-hidden text-ellipsis whitespace-nowrap ${className || ""}`}
      style={{ maxWidth: styleMaxWidth }}
      aria-label={text}
      title={tooltip ? undefined : text}
      onClick={onClick}
    >
      {text}
    </Element>
  );

  if (!tooltip) return content;
  return (
    <Tooltip content={text}>
      {content}
    </Tooltip>
  );
};

export default TruncatedText;


